import { CATEGORIES, CURRENCIES, type Category, type ImpactLevel } from '@/mocks/marketCalendar';
import { Pill } from './ui';

const IMPACTS: { value: ImpactLevel | 'all'; label: string }[] = [
  { value: 'all', label: 'Tất cả' },
  { value: 'high', label: 'Cao' },
  { value: 'medium', label: 'Trung bình' },
  { value: 'low', label: 'Thấp' },
];

export default function Filters({
  currency,
  setCurrency,
  impact,
  setImpact,
  category,
  setCategory,
}: {
  currency: string;
  setCurrency: (v: string) => void;
  impact: ImpactLevel | 'all';
  setImpact: (v: ImpactLevel | 'all') => void;
  category: Category | 'all';
  setCategory: (v: Category | 'all') => void;
}) {
  return (
    <div className="rounded-2xl border border-slate-200/80 bg-white p-4">
      <div className="space-y-3">
        <div>
          <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Currency</p>
          <div className="flex flex-wrap gap-1.5">
            <Pill active={currency === 'all'} onClick={() => setCurrency('all')}>
              All
            </Pill>
            {CURRENCIES.map((c) => (
              <Pill key={c.code} active={currency === c.code} onClick={() => setCurrency(currency === c.code ? 'all' : c.code)}>
                {c.code}
              </Pill>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <div>
            <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Impact</p>
            <div className="flex flex-wrap gap-1.5">
              {IMPACTS.map((f) => (
                <Pill key={f.value} active={impact === f.value} onClick={() => setImpact(f.value)}>
                  {f.label}
                </Pill>
              ))}
            </div>
          </div>
          <div>
            <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Category</p>
            <div className="flex flex-wrap gap-1.5">
              <Pill active={category === 'all'} onClick={() => setCategory('all')}>
                All
              </Pill>
              {CATEGORIES.map((c) => (
                <Pill key={c.value} active={category === c.value} onClick={() => setCategory(category === c.value ? 'all' : c.value)}>
                  {c.label}
                </Pill>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}